import {
  FaDatabase,
  FaSearch,
  FaShieldAlt,
  FaPuzzlePiece,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-postgresql.png";

export const PostgreSQL_CONSTANTS = {
  HERO: {
    title: "OneMind Services — PostgreSQL (One-Click Application) ",
    desc: "Advanced, enterprise-class open-source database system known for reliability, extensibility, and standards compliance.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "PostgreSQL is an advanced open-source object-relational database system known for its reliability, performance, and standards compliance. It supports complex queries, full ACID compliance, and advanced data types such as JSON, XML, and arrays, making it ideal for both transactional and analytical workloads. ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure PostgreSQL instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes PostgreSQL Server, default admin credentials, and optimized system settings.  ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "postgres",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Connect using:  ",
      command: "-U postgres -h <YOUR_INSTANCE_IP> ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: " /etc/postgresql/<version>/main/postgresql.conf ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses:",
      list: ["5432  "],
    },
    note: "Note : Find the configuration file at /etc/postgresql/<version>/main/postgresql.conf for customized tweaks or backup. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaDatabase,
        title: "SQL and JSON Support",
        text: "Supports ANSI SQL and also allows querying and storing JSON data types.",
      },
      {
        icon: FaSearch,
        title: "Indexing & Full-Text Search",
        text: "Includes B-tree, hash, GIN, GiST, and full-text indexing capabilities.",
      },
      {
        icon: FaShieldAlt,
        title: "ACID Compliance",
        text: "Ensures reliable transactions with support for atomicity, consistency, isolation, and durability.",
      },
      {
        icon: FaPuzzlePiece,
        title: "Extensibility",
        text: "Offers support for user-defined types, functions, and custom procedural languages.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or built-in tools like pg_dump, pg_basebackup. ",
      },
      {
        label: "Security Out of the Box",
        text: "Includes TLS, role-based access control, and encrypted storage options. ",
      },
      {
        label: "Scalable Architecture",
        text: "Easily scales with replication and partitioning; supports connection pooling and clustering.  ",
      },
    ],
  },
  SUPPORT: {
    docsText: "PostgreSQL Official Docs",
    docsLink: "https://www.postgresql.org/docs/",
  },
};
